angular.module('swapick')
.controller('UserSwapsListCtrl', UserSwapsListCtrl);


function UserSwapsListCtrl($scope, DataService, DataStrategies,
  $ionicScrollDelegate, $ionicPopup, initialLoaderManager, $q,
  $ionicHistory, $state, $stateParams, Entities, notifyManager ) {

  this.objects = [];
  this.meta = {};

  this.loader = initialLoaderManager.makeLoader(() => {
    // Wait for current auth user
    return Entities.waitForUser().then(u => {
      this.user = u;
    })
    .then(() =>
      // Wait for viewed user
      DataService.users.one($stateParams.userId).one('info').get().then(u => {
        this.viewedUser = u;
        console.log('I AM the viewedUser', this.viewedUser)
      })
    )
    .then(() => {
      // Build methods for swaps fetching
      DataStrategies.createPagerMethods(
        this, $scope,
        {
          method: DataService.swaps, callMethodName: 'getList', pageSize: 50,
          params: () => ({ type: 'archivio', user_id: this.viewedUser.id })
        }
      );
      // Wait for viewe user swaps
      return this.loadMore();
    });
  }, false);

  this.getItemsForUid = (objs, uId) => {
    let o = _.groupBy(objs, 'utente');
    return o[uId];
  };

  $scope.$on('$ionicView.beforeEnter', () => {
    if (!this.objects.length) {
      this.loader.load();
    }
  });
}



// WEBPACK FOOTER //
// ./src/controllers/user-swaps-list-controller.js